module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dl-register-container",
    on: {
      "click": _vm.close
    }
  }, [_c('transition', {
    attrs: {
      "name": "dl-register-toggle"
    },
    on: {
      "after-leave": _vm.afterHidden,
      "before-enter": _vm.onAnimationStart,
      "before-leave": _vm.onAnimationStart,
      "after-enter": _vm.onAnimationEnd
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "dl-register",
    on: {
      "click": function($event) {
        _vm.stopClickPropagation($event)
      }
    }
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('str.CreateAccount')))]), _vm._v(" "), _c('div', {
    staticClass: "line-container"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('str.FirstName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    class: _vm.invalidFields & _vm.keys.firstname ? 'invalid' : '',
    attrs: {
      "placeholder": _vm.$t('str.YourFirstName'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('str.LastName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    class: _vm.invalidFields & _vm.keys.lastname ? 'invalid' : '',
    attrs: {
      "placeholder": _vm.$t('str.YourLastName'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('str.EmailAddress')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: _vm.invalidFields & _vm.keys.email ? 'invalid' : '',
    attrs: {
      "placeholder": _vm.$t('str.Email'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line-container"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('str.Password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    class: _vm.invalidFields & _vm.keys.password1 ? 'invalid' : '',
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('str.Password'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('str.ReConfirmPassword')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    class: _vm.invalidFields & _vm.keys.password2 ? 'invalid' : '',
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('str.ReConfirmPassword'),
      "disabled": _vm.isRegistering
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('str.Captcha')))]), _vm._v(" "), _c('div', [_c('div', {
    class: ['g-recaptcha', _vm.invalidFields & _vm.keys.captcha ? 'invalid' : ''],
    attrs: {
      "name": "captcha",
      "data-sitekey": _vm.rcaptSigKey
    }
  })])]), _vm._v(" "), (!!_vm.errorMessage) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "footer"
  }, [_c('button', {
    staticClass: "bt-reset",
    attrs: {
      "disabled": _vm.isRegistering
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Reset')))]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.isRegistering
    },
    on: {
      "click": _vm.signup
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Signup')))])])]), _vm._v(" "), _c('a', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03003a1e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Register.vue
// module id = 456
// module chunks = 0